import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { EvtHeader } from "components/header";
import DashboardMenu from "@/components/menu";
import { DropdownMenuItem } from "ui/components/dropdown-menu";
import { PermissionControlledInput } from "permissions/components/input";
import SurveyBanner from "../components/banner";
import SurveyFeedbackForm from "components-v2/survey-form/index.jsx";
import client from "directus/src/client";
import { StatusDisplay } from "components-v2/status/display";
import { ShareSurveyDialog } from "../components/share-survey-dialog";
import { Button } from "ui/components/button";
import { toast } from "sonner";
import EditItemButton from "components/buttons/edit";
import HeaderPortal from "components/portal/header-portal";

const SurveyDetail = () => {
    const { surveyId } = useParams();
    const [surveyDetails, setSurveyDetails] = useState(null);
    const [isShareDialogOpen, setIsShareDialogOpen] = useState(false);

    return (
        <div className="flex-1">
            {surveyDetails?.status && surveyDetails.status !== "submitted" ? <SurveyBanner /> : null}
            <EvtHeader
                title={surveyDetails?.title || "Loading..."}
                description={surveyDetails?.status ? <StatusDisplay status={surveyDetails.status} /> : null}
            />

            {surveyDetails && surveyDetails.status !== "submitted" ? (
                <DashboardMenu>
                    <DropdownMenuItem>
                        <PermissionControlledInput
                            rule="update:AM"
                            collection="surveys"
                        >
                            <Link to={`edit`} variant="ghost">
                                Submit on behalf
                            </Link>
                        </PermissionControlledInput>
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => setIsShareDialogOpen(true)}>
                        <PermissionControlledInput
                            rule="update:AM"
                            collection="surveys"
                        >
                            Share
                        </PermissionControlledInput>
                    </DropdownMenuItem>
                </DashboardMenu>
            ) : 
            <HeaderPortal>
                <PermissionControlledInput
                    rule="update:AM"
                    collection="surveys"
                >
                    <EditItemButton />
                </PermissionControlledInput>
            </HeaderPortal>
            }

            <div className="px-6 ">
                <SurveyFeedbackForm
                    itemId={surveyId}
                    client={client}
                    readMode={true}
                    clientMode={false}
                    onDataLoad={(data) => setSurveyDetails(data)}
                    amReadMode={true}
                />
            </div>

            <ShareSurveyDialog
                open={isShareDialogOpen}
                onOpenChange={setIsShareDialogOpen}
                surveyId={surveyId}
                surveyDetails={surveyDetails}
                onSuccess={() => {
                    toast.success("Survey shared successfully");
                }}
            />
        </div>
    );
};

export default SurveyDetail;
